<template>
  <button class="btn btn-red w-100" data-bs-toggle="modal" data-bs-target="#post-remove-force">
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-copy-x">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <path stroke="none" d="M0 0h24v24H0z" />
      <path d="M7 9.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z" />
      <path d="M4.012 16.737a2 2 0 0 1 -1.012 -1.737v-10c0 -1.1 .9 -2 2 -2h10c.75 0 1.158 .385 1.5 1" />
      <path d="M11.5 11.5l4.9 5" />
      <path d="M16.5 11.5l-5.1 5" />
    </svg>

    <template v-if="obj.status.isPreDeletedForce()">
      Повторить полное удаление
    </template>
    <template v-else>
      Удалить полностью
    </template>
  </button>

  <div class="modal modal-blur fade" id="post-remove-force" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Полное удаление</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="closeModal"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            Это действие полностью удалит этот пост с сайта!
          </div>
          <button class="btn btn-red w-100 mb-3" :class="{'disabled': isDisabledBtn()}" @click="onDelete">
            <span class="spinner-border spinner-border-sm me-2" v-show="isShowLoadingBtn()"></span>
            Удалить полностью
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, ref} from "vue"
import Api from "./services/Api"
import Notify from "@/services/Notify"

export default defineComponent({
  name: "RemoveForce",
  emits: [
      "onPostRemove",
  ],
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  setup(props, {emit}) {
    let deleting = ref(false)
    let closeModal = ref(null)

    let postId = ref(props.data["post_id"])
    let status = ref(props.data["status"])

    function onDelete() {
      if (confirm("Вы действительно хотите полностью удалить этот пост?")) {
        startDeleting()

        Api.siteDeleteForce(postId.value).then(() => {
          setTimeout(() => {
            emit('onPostRemove', true)
          }, 1500)
        }).then(() => {
          Notify.success("Поставлена задача на полное удаление")
          closeModalWindow()
        }).catch(() => {
          emit('onPostRemove', false)
        }).finally(() => {
          stopDeleting()
        })
      }
    }

    function isDisabledBtn() {
      return deleting.value === true
    }

    function isShowLoadingBtn() {
      return isDisabledBtn()
    }

    function startDeleting() {
      deleting.value = true
    }

    function stopDeleting() {
      deleting.value = false
    }

    function closeModalWindow() {
      closeModal.value.click()
    }

    let obj = {
      status: {
        isPreDeletedForce: () => {
          return status.value === "preDeletedForce"
        },
      },
    }

    return {
      onDelete,
      isDisabledBtn,
      isShowLoadingBtn,
      closeModal,
      obj,
    }
  },
})
</script>

<style scoped>

</style>
